import { Injectable, EventEmitter } from '@angular/core';
import { GuidHelper } from '../helpers/guid-helper';

@Injectable({ providedIn: 'root' })
export class LoadingService {

    public loadingStarted = new EventEmitter<LoadingInstance>();
    public loadingCompleted = new EventEmitter<LoadingInstance>();

    private loadingInstances = new Array<LoadingInstance>();

    constructor() {

    }

    startLoading(): LoadingInstance {
        let loadingInstance = new LoadingInstance();
        loadingInstance.id = GuidHelper.generate();
        loadingInstance.completed = false;
        this.loadingInstances.push(loadingInstance);
        this.loadingStarted.next(loadingInstance);
        return loadingInstance;
    }

    stopLoading(loadingInstance: LoadingInstance) {
        if (this.loadingInstances.indexOf(loadingInstance) > -1) {
            this.loadingInstances.splice(this.loadingInstances.indexOf(loadingInstance), 1);
            loadingInstance.completed = true;
        }
        this.loadingCompleted.next(loadingInstance);
    }

    stopAll() {
        this.loadingInstances.splice(0, this.loadingInstances.length);
    }

    isLoading() {
        return this.loadingInstances.length > 0;
    }
}

export class LoadingInstance {
    id: string;
    completed: boolean;
}